import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import axiosInstance from "axiosConfig";
import { Toast } from "shared";
import { TOAST_TYPES_ENUM } from "enums";
import { queryClient } from "App";

export const useGenerateReport = (
  options?: UseMutationOptions<any, Error, void>
) => {
  return useMutation({
    ...options,
    mutationKey: ["generateReport"],
    mutationFn: async () => {
      return axiosInstance.post("/reports").then((res) => res.data);
    },
    onMutate: (variables) => {
      Toast({
        message: "Trwa generowanie raportu...",
        type: TOAST_TYPES_ENUM.LOADING,
        id: "generate-report",
      });
      if (options && options.onMutate) {
        return options.onMutate(variables);
      }
    },
    onSuccess: (data, variables, context) => {
      Toast({
        message: "Pomyślnie wygenerowano raport.",
        type: TOAST_TYPES_ENUM.SUCCESS,
        id: "generate-report",
      });
      queryClient.invalidateQueries({ queryKey: ["reports"] });
      queryClient.invalidateQueries({ queryKey: ["reportComponents"] });
      if (options && options.onSuccess) {
        options.onSuccess(data, variables, context);
      }
    },
    onError: (error: any, variables, context) => {
      const errorMessage =
        error?.data?.message || "Błąd podczas generowania raportu.";
      Toast({
        message: errorMessage,
        type: TOAST_TYPES_ENUM.ERROR,
        id: "generate-report",
      });
      if (options && options.onError) {
        options.onError(error, variables, context);
      }
    },
  });
};

export default useGenerateReport;
